import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { LanguageProvider } from "./context/LanguageContext";

// Pages
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import OrdersPage from "./pages/OrdersPage";

// Admin Pages
import {
  AdminLayout,
  AdminDashboard,
  AdminProducts,
  AdminProductForm,
  AdminCategories,
  AdminBrands,
  AdminOrders,
  AdminCustomers,
  AdminSettings,
  AdminCoupons,
  AdminShipping,
  AdminReports,
  AdminReviews,
  AdminNotifications,
  AdminUsers
} from "./pages/admin";

// Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              {/* Public Routes with Navbar/Footer */}
              <Route path="/" element={
                <div className="min-h-screen flex flex-col">
                  <Navbar />
                  <main className="flex-1"><HomePage /></main>
                  <Footer />
                </div>
              } />
              <Route path="/products" element={
                <div className="min-h-screen flex flex-col">
                  <Navbar />
                  <main className="flex-1"><ProductsPage /></main>
                  <Footer />
                </div>
              } />
              <Route path="/products/:id" element={
                <div className="min-h-screen flex flex-col">
                  <Navbar />
                  <main className="flex-1"><ProductDetailPage /></main>
                  <Footer />
                </div>
              } />
              <Route path="/cart" element={
                <div className="min-h-screen flex flex-col">
                  <Navbar />
                  <main className="flex-1"><CartPage /></main>
                  <Footer />
                </div>
              } />
              <Route path="/checkout/success" element={
                <div className="min-h-screen flex flex-col">
                  <Navbar />
                  <main className="flex-1"><CheckoutSuccessPage /></main>
                  <Footer />
                </div>
              } />
              <Route path="/login" element={
                <div className="min-h-screen flex flex-col">
                  <Navbar />
                  <main className="flex-1"><LoginPage /></main>
                  <Footer />
                </div>
              } />
              <Route path="/register" element={
                <div className="min-h-screen flex flex-col">
                  <Navbar />
                  <main className="flex-1"><RegisterPage /></main>
                  <Footer />
                </div>
              } />
              <Route path="/forgot-password" element={
                <div className="min-h-screen flex flex-col">
                  <Navbar />
                  <main className="flex-1"><ForgotPasswordPage /></main>
                  <Footer />
                </div>
              } />
              <Route path="/reset-password" element={
                <div className="min-h-screen flex flex-col">
                  <Navbar />
                  <main className="flex-1"><ResetPasswordPage /></main>
                  <Footer />
                </div>
              } />
              <Route path="/orders" element={
                <div className="min-h-screen flex flex-col">
                  <Navbar />
                  <main className="flex-1"><OrdersPage /></main>
                  <Footer />
                </div>
              } />

              {/* Admin Routes - No Navbar/Footer */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="products/new" element={<AdminProductForm />} />
                <Route path="products/edit/:id" element={<AdminProductForm />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="brands" element={<AdminBrands />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="coupons" element={<AdminCoupons />} />
                <Route path="shipping" element={<AdminShipping />} />
                <Route path="reports" element={<AdminReports />} />
                <Route path="reviews" element={<AdminReviews />} />
                <Route path="notifications" element={<AdminNotifications />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
            </Routes>
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
